import { render, staticRenderFns } from "./AssetVersionsTab.vue?vue&type=template&id=756c25db&scoped=true&"
import script from "./AssetVersionsTab.vue?vue&type=script&lang=js&"
export * from "./AssetVersionsTab.vue?vue&type=script&lang=js&"
import style0 from "./AssetVersionsTab.vue?vue&type=style&index=0&id=756c25db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c25db",
  null
  
)

export default component.exports